import type { User } from '@/types/auth';
import { getSelfServiceBasePath } from '@/types/auth';
import { storage, AUTH_USER_KEY } from '@/utils/storage';

export function getCurrentSelfServiceBasePath(): '/patient' | '/nushu-x' {
  const user = storage.get<User>(AUTH_USER_KEY);
  if (!user) return '/patient';
  return getSelfServiceBasePath(user.username);
}
